import { webInquiryConstants } from "../_constants";
import { webInquiryService } from "../_services";
import { alertActions } from ".";

export const webInquiryActions = {
  sendWebInquiry
};


function sendWebInquiry(webInquiry) {
  return (dispatch) => {
    dispatch(request(webInquiry));

    webInquiryService.sendWebInquiry(webInquiry).then(
      (webInquiry) => {
        dispatch(success(webInquiry));
        dispatch(alertActions.success("The web inquiry was sent successfully."));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
        console.log(alertActions.error(error.toString()));
      }
    );
  };

  function request(webInquiry) {
    return { type: webInquiryConstants.SEND_WEB_INQUIRY_REQUEST, webInquiry };
  }
  function success(webInquiry) {
    return { type: webInquiryConstants.SEND_WEB_INQUIRY_SUCCESS, webInquiry };
  }
  function failure(error) {
    return { type: webInquiryConstants.SEND_WEB_INQUIRY_FAILURE, error };
  }
}
